import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    ArmService,
    AuthenticationService,
    DossierMedicalService,
    EspaceClientService,
    User,
} from '@kv-common-components/kx-services';
import { FormatHelperService } from '@shared/services/format-helper.service';
import { I18nPipe } from '@shared/pipes/i18n.pipe';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-appointment-details',
    templateUrl: 'appointment-details.component.html',
})
export class AppointmentDetailsRdvArmComponent implements OnInit, OnDestroy {
    centersLoaded = false;
    idDossierMedical: string;
    coordonneesGps: any;
    listeRdvMedical: any;
    informationPraticien: any;
    dateDebut: any;
    contentRdvMedical: any[];
    accordeonOpened = false;
    currentIndex: any;
    selectedItem: any[] = [];
    limitedDate = 5;
    limitedHours = 8;
    linkShowMore = true;
    selectedListeRdv: any[] = [];
    currentHoursSelected: any;
    listeRendezVousMedical: any[] = [];
    selectedHours: any;
    currentIdPratcien: string;
    currentRdv: any;
    showModalModification = false;
    currentRDVToEdit: any;
    modalBody: string;
    selectedHoursToConfirmModal: any;
    showModalWebCallBack = false;
    contentWebCallBack: string;
    telephone: any;
    currentProject: any;
    currentUser: User;
    originalText: string;

    paramsSubscription: Subscription;

    constructor(
        private activatedRoute: ActivatedRoute,
        private armService: ArmService,
        private espaceClientService: EspaceClientService,
        private authService: AuthenticationService,
        private dossierMedicalService: DossierMedicalService,
        private i18nPipe: I18nPipe,
        private router: Router
    ) {}

    ngOnInit() {
        this.currentUser = this.authService.currentUserValue;
        this.espaceClientService
            .getEspaceClient(this.currentUser.idPersonne)
            .subscribe((espaceClient) => {
                this.currentProject = espaceClient.listeProjetsCredits.find(
                    (projet) =>
                        projet.idProjetCredit === this.currentUser.idDossier
                );

                const idAia = espaceClient.personne.idAia;
                this.telephone = espaceClient.personne.telephone;
                this.dossierMedicalService
                    .getIdDossierMedical(
                        idAia,
                        this.currentProject.idProjetCredit
                    )
                    .subscribe((respDossierMedical) => {
                        this.idDossierMedical =
                            respDossierMedical.idDossierMedical;
                        this.armService
                            .getDossierMedical(this.idDossierMedical)
                            .subscribe((resultDossMedicalAndRDV) => {
                                this.listeRendezVousMedical =
                                    resultDossMedicalAndRDV.listeRendezVousMedical;
                            });
                        this.paramsSubscription =
                            this.activatedRoute.params.subscribe((param) => {
                                this.currentIdPratcien = param.centerIdApi;
                                this.armService
                                    .getPraticien(this.currentIdPratcien)
                                    .subscribe((respPraticienDetail) => {
                                        const listePraticien = [
                                            this.currentIdPratcien.toString(),
                                        ];
                                        this.informationPraticien =
                                            respPraticienDetail;
                                        this.coordonneesGps =
                                            this.informationPraticien.coordonneesGps;

                                        this.armService
                                            .rechercheRendezVous(
                                                this.idDossierMedical,
                                                this.coordonneesGps.latitude,
                                                this.coordonneesGps.longitude,
                                                listePraticien
                                            )
                                            .subscribe((listeRdvMedical) => {
                                                this.listeRdvMedical =
                                                    listeRdvMedical;
                                                this.getListeDisponiblite(
                                                    this.listeRdvMedical
                                                        .listeResultatRecherche[0]
                                                        .listeRendezVousMedical
                                                );
                                                this.centersLoaded = true;
                                            });
                                    });
                            });
                    });
            });
    }

    ngOnDestroy() {
        if (this.paramsSubscription) {
            this.paramsSubscription.unsubscribe();
        }
    }

    getListeDisponiblite(listeRendezVousMedical: any) {
        // ressortir les dates de maniere distinctes et sans doublons
        const listeOfDistinctDate = [
            ...new Set(
                listeRendezVousMedical.map((item) =>
                    FormatHelperService.getDateFormatted(
                        item.dateDebut,
                        'YYYY-MM-DD'
                    )
                )
            ),
        ];

        this.contentRdvMedical = [];

        // construire un tableau en regroupant les dates distinctes avec les rdv associés.
        listeOfDistinctDate.forEach((element) => {
            this.contentRdvMedical.push({
                id: listeOfDistinctDate.indexOf(element),
                dateDebut: element,
                limitedHoursToShow: this.limitedHours,
                showAllItems: listeRendezVousMedical <= this.limitedHours,
                rdvByDateDebut: listeRendezVousMedical.filter(
                    (e) =>
                        FormatHelperService.getDateFormatted(
                            e.dateDebut,
                            'YYYY-MM-DD'
                        ) === element
                ),
            });
        });
    }

    showUnlimitedRdv() {
        this.limitedDate = this.contentRdvMedical.length;
        this.linkShowMore = false;
    }

    showUnlimitedHours(index) {
        this.contentRdvMedical[index].limitedHoursToShow =
            this.contentRdvMedical[index].rdvByDateDebut.length;
        this.contentRdvMedical[index].showAllItems = true;
    }

    getLimitedTimes(listeOfDate, limitedHours) {
        return listeOfDate.slice(0, limitedHours);
    }

    selectHours(selectedHours) {
        // rechercher si un rdv est deja en cours pour ce cabinet
        if (this.listeRendezVousMedical.length === 0) {
            this.selectedHours = selectedHours;
            this.currentHoursSelected = selectedHours.dateDebut;
        } else {
            this.currentRDVToEdit = this.getModalBody(
                selectedHours.dateDebut,
                this.informationPraticien.libelleCentre
            );
            this.showModalModification = true;
            this.selectedHoursToConfirmModal = selectedHours;
        }
    }

    formatDate(date: string): string {
        const formatDate = new Date(date.toString());
        const options: Intl.DateTimeFormatOptions = {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
        };
        return formatDate.toLocaleDateString('fr-FR', options);
    }

    formatHour(date: string): string {
        return FormatHelperService.getDateFormattedForAppointment(
            date,
            'HH[h]mm'
        );
    }

    selectItem(item) {
        const checkContent = !this.selectedItem.some(
            (element) => element === item
        );
        if (checkContent) {
            this.selectedItem.push(item);
        } else {
            this.selectedItem = this.selectedItem.filter(
                (element) => element !== item
            );
        }
    }

    dateRDVIsOpen(item) {
        return this.selectedItem.some((element) => element === item);
    }

    goToAppointmentTimeTable() {
        this.armService
            .postRendezVousMedical(this.idDossierMedical, this.selectedHours)
            .subscribe((response) => {
                this.showModalModification = false;
                //history.state = [];
                //if result ok redirect to confirmation page.
                this.router.navigateByUrl('/souscription/appointment-details');
            });
    }

    confirmModal() {
        this.selectedHours = this.selectedHoursToConfirmModal;
        // delete le rdv courant
        this.armService
            .deleteRendezVousMedical(
                this.idDossierMedical,
                this.listeRendezVousMedical[0]
            )
            .subscribe((response) => {
                this.goToAppointmentTimeTable();
            });
    }

    closeModal() {
        this.showModalModification = false;
    }

    getModalBody(dateDebut, libelleCentre) {
        this.originalText = this.i18nPipe.transform(
            'appointment.appointment-details.popin.edit.label'
        );
        const matchRegex = this.originalText.match(/(%s)/);
        this.originalText = this.originalText.replace(
            matchRegex[0],
            '<b>' +
                FormatHelperService.getDateFormattedForAppointment(
                    dateDebut,
                    'dddd DD MMMM, à HH[h]mm'
                ) +
                '</b>'
        );
        this.originalText = this.originalText.replace(
            matchRegex[1],
            '<b>' + libelleCentre + '</b>'
        );

        return this.originalText;
    }

    callARM() {
        this.showModalWebCallBack = true;
        const modalCallBackBody = this.i18nPipe.transform(
            'appointment.appointment-type.modal.phone.confirmation'
        );
        const phoneNumer = this.buildPhoneNumer(this.telephone);
        this.contentWebCallBack = modalCallBackBody.replace('%s', phoneNumer);
    }

    closeWebCallBackModal() {
        this.showModalWebCallBack = false;
    }

    confirmWebCallBackModal() {
        this.armService
            .postWebCallBack(this.idDossierMedical, this.currentIdPratcien)
            .subscribe((success) => {
                this.router.navigateByUrl(
                    '/souscription/document-medicale/document-list'
                );
            });
        this.closeWebCallBackModal();
    }

    buildPhoneNumer(telephone) {
        const matchRegex = telephone.match(/(\d{2})(\d{6})(\d{2})/);
        telephone = telephone.replace(matchRegex[2], ' ** ** ** ');
        telephone = '<span class="phone phone--green">' + telephone + '</span>';
        return telephone;
    }
}
